<template>
  <div>
    <data-table
      :title="'Sites for ' + category"
      titleClass="text-info"
      table-ref="orgSitesTable"
      :url="'/org/sites/' + Number(this.org_id)"
      :fields="fields"
      :show-search="false"
      :add-action="action"
      :add-props="addProps"
      sort-field="site.siteName">

      <template #info="props">
        <popup
          :show-text="false"
          button-text=""
          :heading="props.rowData.site.siteName"
          button-icon="fa fa-info"
          button-style="primary"
          :show-save="false">
          <el-row>
            <el-col :span="24">
              <site-card :site-data="props.rowData.site" />
            </el-col>

            <el-col :span="24">
              <site-info :row-data="props.rowData.site" />
            </el-col>
          </el-row>
        </popup>
      </template>

      <template #delete="props">
        <el-button
          v-if="isManager()"
          @click="deleteSite(props.rowData)"
          type="danger"
          icon="fa fa-trash"
          circle
          size="small" />
      </template>

    </data-table>

  </div>
</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'

import AddSitesOrg from './AddSitesOrg'

import SiteCard from '@/components/sites/SiteCard'
import SiteInfo from '@/components/sites/SiteInfo'

export default {

  mixins: [SiteMixins],

  components: {
    SiteCard,
    SiteInfo
  },

  props: {

    orgId: {
      type: Number,
      required: true
    },

    category: {
      type: String,
      required: true
    },

    readOnly: {
      type: Boolean,
      default: true
    }

  },


  watch: {
    orgId: function (changed) {
      this.org_id = changed
      this.addProps.orgId = changed
    }

  },


  methods: {
    deleteSite (row) {
      let id = row.id
      let siteName = row.site.siteName

      if (id && siteName) {
        this.deleteItem(this, id, '/org/sites', 'Delete site ' + siteName, null, true, 'orgSitesTable')
      } else {
        this.$message({type: 'warning', message: 'No ID or Site name, can\'t delete.'})
      }
    }
},


  data () {
    return {

      org_id: this.orgId,

      action: AddSitesOrg,
      addProps: {
        orgId: this.orgId,
        category: this.category
      },

      fields: [
        {
          name: '__sequence',
          title: '#'
        },
        {
          name: 'site.status',
          title: 'Status',
          callback: this.siteStatus
        },
        {
          name: 'site.siteName',
          title: 'Site Name'
        },
        {
          name: '__slot:info'
        },
        {
          name: '__slot:delete'
        }
      ]
    }
  }
}
</script>
